import {
  RadioButtonGroupMapping,
  RadioButtonType,
} from '@labrav/react-components'

export enum subscriptionsRangeStatus {
  ACTIVE = 'active',
  SEVEN = '7',
  THIRTY = '30',
  NINETY = '90',
  EXPIRED = 'expired',
  ALL = 'All',
}

export const isExpiringSoonSubscriptionStatusList = [
  subscriptionsRangeStatus.NINETY,
  subscriptionsRangeStatus.SEVEN,
  subscriptionsRangeStatus.THIRTY,
]

export const subscriptionFilterCriteriaOptions: RadioButtonGroupMapping[] = [
  {
    key: subscriptionsRangeStatus.ACTIVE,
    label: 'Active',
    type: RadioButtonType.STANDARD,
  },
  {
    key: subscriptionsRangeStatus.SEVEN,
    label: 'Expiring in 7 days',
    type: RadioButtonType.STANDARD,
  },
  {
    key: subscriptionsRangeStatus.THIRTY,
    label: 'Expiring in 30 days',
    type: RadioButtonType.STANDARD,
  },
  {
    key: subscriptionsRangeStatus.NINETY,
    label: 'Expiring in 90 days',
    type: RadioButtonType.STANDARD,
  },
  {
    key: subscriptionsRangeStatus.EXPIRED,
    label: 'Expired',
    type: RadioButtonType.STANDARD,
  },
  {
    key: subscriptionsRangeStatus.ALL,
    label: 'All',
    type: RadioButtonType.STANDARD,
  },
]

export const subscriptionFilterCriteriaOptionsGcp: RadioButtonGroupMapping[] = [
  {
    key: subscriptionsRangeStatus.ACTIVE,
    label: 'Active',
    type: RadioButtonType.STANDARD,
  },
  {
    key: subscriptionsRangeStatus.SEVEN,
    label: 'Ending in 7 days',
    type: RadioButtonType.STANDARD,
  },
  {
    key: subscriptionsRangeStatus.THIRTY,
    label: 'Ending in 30 days',
    type: RadioButtonType.STANDARD,
  },
  {
    key: subscriptionsRangeStatus.NINETY,
    label: 'Ending in 90 days',
    type: RadioButtonType.STANDARD,
  },
  {
    key: subscriptionsRangeStatus.EXPIRED,
    label: 'Ended',
    type: RadioButtonType.STANDARD,
  },
  {
    key: subscriptionsRangeStatus.ALL,
    label: 'All',
    type: RadioButtonType.STANDARD,
  },
]

const subscriptionListSortFieldToApi: Record<string, string> = {
  buyerCompanyName: 'buyer_company_name',
  productName: 'product_name',
  privateOfferName: 'start_date',
  contractExpirationDate: 'expiration_date',
  contractStartDate: 'start_date',
  offerType: 'start_date',
}

export type SubscriptionSortConfig = {
  key: string
  direction: 'asc' | 'desc'
} | null

export const subscriptionListSortToApiParams = (
  config: SubscriptionSortConfig | undefined
): { sortBy?: string; sortOrder?: 'asc' | 'desc' } => {
  if (config == null) {
    return {}
  }
  const sortBy = subscriptionListSortFieldToApi[config.key] || config.key
  return {
    sortBy,
    sortOrder: config.direction,
  }
}

export const parseSubscriptionExpiringDaysParam = (
  expiringDays?: string
): number | undefined => {
  if (expiringDays == null || expiringDays === '') {
    return undefined
  }
  const n = parseInt(String(expiringDays), 10)
  return Number.isNaN(n) ? undefined : n
}

export type GcpSubscriptionListApiStatus =
  | 'ACCOUNT_PENDING'
  | 'ACCOUNT_ACTIVE'
  | 'ACCOUNT_REJECTED'
  | 'SUBSCRIPTION_EXPIRED'

export const subscriptionFilterStatusToGcpApiParam = (
  status?: string
): GcpSubscriptionListApiStatus | undefined => {
  if (status == null || status === '') {
    return undefined
  }
  const s = String(status).trim()
  if (s === '' || s === subscriptionsRangeStatus.ALL) {
    return undefined
  }
  const upper = s.toUpperCase()
  if (
    upper === 'ACCOUNT_PENDING' ||
    upper === 'ACCOUNT_ACTIVE' ||
    upper === 'ACCOUNT_REJECTED' ||
    upper === 'SUBSCRIPTION_EXPIRED'
  ) {
    return upper as GcpSubscriptionListApiStatus
  }
  if (s === subscriptionsRangeStatus.ACTIVE) {
    return 'ACCOUNT_ACTIVE'
  }
  if (s === subscriptionsRangeStatus.EXPIRED) {
    return 'SUBSCRIPTION_EXPIRED'
  }
  return undefined
}
